import { render, staticRenderFns } from "./role-list-header.vue?vue&type=template&id=7be9d1da&scoped=true"
import script from "./role-list-header.vue?vue&type=script&lang=js"
export * from "./role-list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be9d1da",
  null
  
)

export default component.exports